
if (process.client && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service_worker.js', { scope: '/' })
    .then(registration => {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    })
    .catch(error => {
      console.error('Service Worker registration failed:', error);
    });
}